import type { TransactionSigner } from '@passkeys/transaction-signer';
import type { Transactions } from '@passkeys/transactions';

import type { Asset } from '@/types';
import type { TransactionHandlerResult } from '../types.js';

type HandleSolanaTransactionParams = {
  asset: Asset;
  transaction: string;
  walletAccount: string;
  transactions: Transactions;
  transactionSigner: TransactionSigner;
};

export async function handleSolanaTransaction({
  asset,
  transaction,
  walletAccount,
  transactions,
  transactionSigner,
}: HandleSolanaTransactionParams): Promise<TransactionHandlerResult> {
  const { txId, rawTx } = await transactionSigner.signTransaction({
    baseAssetName: asset.baseAssetName,
    assetName: asset.name,
    unsignedTx: {
      txData: { transactionBuffer: Buffer.from(transaction, 'base64') },
      txMeta: Object.create(null),
    },
  });

  await transactions.broadcast({
    assetName: asset.name,
    signedTx: rawTx,
    walletAccount,
  });

  return { txId };
}
